/**
 * SendNotifications Class
 * Handles Dual-Select Toggle, Multi-Select-All logic, and Quick Templates.
 */
export default class SendNotifications {
    constructor() {
        this.container = document.querySelector('.send-notification');
        if (!this.container) return;

        // Toggles & Wrappers
        this.typeRadios = this.container.querySelectorAll('input[name="recipient_type"]');
        this.wrapperSingle = this.container.querySelector('#wrapper_single');
        this.wrapperMultiple = this.container.querySelector('#wrapper_multiple');

        // Select Elements
        this.singleSelect = this.container.querySelector('#member_select_single');
        this.multiSelect = this.container.querySelector('#member_select_multi');

        // Form Fields
        this.subjectInput = this.container.querySelector('#subject');
        this.messageInput = this.container.querySelector('#message');
        this.templateBtns = this.container.querySelectorAll('.template-item');
        
        this.allWasSelected = false;

        // Predefined Template Data
        this.templates = {
            'deadline': {
                subject: '🚨 Deadline Approaching: Get your picks in!',
                message: 'The games are about to start! Don\'t forget to login and lock in your picks before the window closes.'
            },
            'dues': {
                subject: '💰 Pay your damn dues!',
                message: 'The pot is waiting on you. Please get your league dues in ASAP so we can keep the prize pool accurate!'
            },
            'weekly-results': {
                subject: '🏆 Week Results are Posted!',
                message: 'The dust has settled. Head over to the dashboard to see the weekly winners and updated standings!'
            },
            'custom': {
                subject: '',
                message: ''
            }
        };

        this.init();
    }

    init() {
        // Toggle Logic (Single vs Multiple)
        this.typeRadios.forEach(radio => {
            radio.addEventListener('change', () => this.toggleRecipientMode());
        });

        // Multi-select-all logic (Inside the multi-select box)
        if (this.multiSelect) {
            this.multiSelect.addEventListener('change', () => this.handleMultiSelectionChange());
        }

        // Template button logic
        this.templateBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.applyTemplate(btn.dataset.template);
            });
        });
    }

    /**
     * Toggles between the standard dropdown and the multi-select list
     */
    toggleRecipientMode() {
        const isMultiple = this.container.querySelector('#type_multiple').checked;

        if (isMultiple) {
            this.wrapperSingle.classList.add('d-none');
            this.wrapperMultiple.classList.remove('d-none');
            // Reset single select to "all" to prevent confusion if they switch back
            this.singleSelect.value = 'all';
        } else {
            this.wrapperSingle.classList.remove('d-none');
            this.wrapperMultiple.classList.add('d-none');
            // Clear multi-select choices when hiding it
            Array.from(this.multiSelect.options).forEach(opt => opt.selected = false);
            this.allWasSelected = false;
            this.updateMultiVisualState();
        }
    }

    /**
     * Injects template data into form fields with visual feedback
     */
    applyTemplate(key) {
        const data = this.templates[key];
        if (!data) return;

        this.subjectInput.value = data.subject;
        this.messageInput.value = data.message;

        // Visual feedback - flash the inputs
        [this.subjectInput, this.messageInput].forEach(el => {
            el.classList.add('is-valid');
            setTimeout(() => el.classList.remove('is-valid'), 1000);
        });
    }

    /**
     * Logic for the "--- ALL ---" option inside the Multiple Select
     */
    handleMultiSelectionChange() {
        const options = Array.from(this.multiSelect.options);
        const allOption = options.find(opt => opt.value === 'all');
        const memberOptions = options.filter(opt => opt.value !== 'all');
        
        const allIsCurrentlySelected = allOption.selected;

        if (allIsCurrentlySelected && !this.allWasSelected) {
            memberOptions.forEach(opt => opt.selected = true);
            this.allWasSelected = true;
        } 
        else if (!allIsCurrentlySelected && this.allWasSelected) {
            memberOptions.forEach(opt => opt.selected = false);
            this.allWasSelected = false;
        }
        else {
            const allActuallySelected = memberOptions.every(opt => opt.selected);
            allOption.selected = allActuallySelected;
            this.allWasSelected = allActuallySelected;
        }

        this.updateMultiVisualState();
    }

    updateMultiVisualState() {
        if (this.allWasSelected) {
            this.multiSelect.classList.add('bg-light', 'border-primary');
        } else {
            this.multiSelect.classList.remove('bg-light', 'border-primary');
        }
    }
}